var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      class: _vm.className,
      staticStyle: { width: "100%" },
    },
    [
      _vm._t("header"),
      _c(
        "div",
        {
          style: {
            marginBottom: _vm.safeBottomHeight,
            paddingLeft: _vm.paddingLeft,
            paddingRight: _vm.paddingRight,
          },
        },
        [_c("div", { style: _vm.innerStyle }, [_vm._t("default")], 2)]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }